import React from 'react';
import { useTranslation } from 'react-i18next';
import LandingHeader from '../components/LandingHeader';
import SiteFooter from '../components/SiteFooter';
import { getLegalEntity, isRussianRegion } from '../config/legalEntity';

export default function AboutPage() {
    const { t } = useTranslation('about');
    const entity = getLegalEntity();
    const isRu = isRussianRegion();

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--sp-gray-50)' }}>
            <LandingHeader />
            <main className="page-wrapper" style={{ flex: 1, maxWidth: 720, margin: '0 auto', padding: '32px 20px 48px', lineHeight: 1.65 }}>
                <h1 className="page-h1">{t('title')}</h1>

                <section style={{ marginBottom: 32 }}>
                    <h2 className="page-h2">{t('missionTitle')}</h2>
                    <p style={{ color: '#475569', margin: 0 }}>{t('missionText')}</p>
                </section>

                <section style={{ marginBottom: 32 }}>
                    <h2 className="page-h2">{t('productTitle')}</h2>
                    <p style={{ color: '#475569', margin: 0 }}>
                        {isRu ? t('productText') : t('productTextPublic', { defaultValue: t('productText') })}
                    </p>
                </section>

                <section>
                    <h2 className="page-h2">{t('companyTitle')}</h2>
                    {isRu ? (
                        <p style={{ color: '#475569', margin: 0 }}>
                            {entity.nameShort}
                            <br />
                            Email: support@sportprogress.ru
                        </p>
                    ) : (
                        <p style={{ color: '#475569', margin: 0 }}>
                            IE Galstyan Termine Galusti
                            <br />
                            Yerevan, Republic of Armenia
                            <br />
                            Email: {entity.privacyEmail?.replace('privacy@', 'support@') || 'support@sportprogress.app'}
                        </p>
                    )}
                </section>
            </main>
            <SiteFooter />
        </div>
    );
}
